import ClosingBalanceColumn from "./ClosingBalanceColumn.js";
import DeviationColumn from "./DeviationColumn.js";
import FormulaColumn from "./FormulaColumn.js";
import ModelFactory from "../../../ModelFactory.js";
import OpeningBalanceColumn from "./OpeningBalanceColumn.js";
import PercentageColumn from "./PercentageColumn.js";
import PeriodChangeColumn from "./PeriodChangeColumn.js";
import RollingPeriodColumn from "./RollingPeriodColumn.js";
import SeparatorColumn from "./SeparatorColumn.js";
import YearToDateColumn from "./YearToDateColumn.js";

/**
 * TODO: write documentation
 */
class ReportColumnFactory extends ModelFactory {
	allClasses() {
		return [
			ClosingBalanceColumn,
			DeviationColumn,
			FormulaColumn,
			OpeningBalanceColumn,
			PercentageColumn,
			PeriodChangeColumn,
			RollingPeriodColumn,
			SeparatorColumn,
			YearToDateColumn,
		];
	}

	allItemClasses() {
		return this.allClasses().filter((klass) => klass.isVisible());
	}

	_getTypeFromJson(json) {
		return json.columnType;
	}
}

const reportColumnFactory = new ReportColumnFactory();

export default reportColumnFactory;
